export type MarkerProgressState='current-start'|'current-completed'|'completed'|'destination'|'future'
// MapLibre supplies position:absolute on the marker itself. Position utilities
// such as Tailwind's `relative` must never be added to this class list.
export const replayMarkerClassName='grid h-9 w-9 place-items-center rounded-full border-2 text-xs font-black shadow-lg transition-colors'

export function markerProgressState(index:number,currentPositionIndex:number,inFlightDestinationIndex?:number):MarkerProgressState{
  if(index===inFlightDestinationIndex)return'destination'
  if(index===currentPositionIndex)return index===0?'current-start':'current-completed'
  if(index<currentPositionIndex)return'completed'
  return'future'
}
